var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10815 10.7667L8.10732 4.77417L13.0606 7.78083L8.10815 10.7658V10.7667ZM18.984 3.735C18.984 3.735 18.8048 2.26583 18.2556 1.61833C17.5581 0.768333 16.7765 0.765 16.4181 0.715C13.8532 0.5 10.0048 0.5 10.0048 0.5H9.99648C9.99648 0.5 6.14815 0.5 3.58398 0.715833C3.22565 0.765833 2.44398 0.77 1.74648 1.61917C1.19648 2.26667 1.01815 3.73583 1.01815 3.73583C1.01815 3.73583 0.833984 5.46167 0.833984 7.1875V8.80583C0.833984 10.5308 1.01732 12.2575 1.01732 12.2575C1.01732 12.2575 1.19648 13.7267 1.74565 14.3742C2.44315 15.2242 3.35898 15.1967 3.76732 15.2858C5.23398 15.4492 10.0007 15.5 10.0007 15.5C10.0007 15.5 13.8532 15.4933 16.4181 15.2775C16.7765 15.2275 17.5581 15.2233 18.2556 14.3742C18.8056 13.7267 18.984 12.2575 18.984 12.2575C18.984 12.2575 19.1673 10.5317 19.1673 8.80583V7.1875C19.1673 5.4625 18.984 3.73583 18.984 3.73583V3.735Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLive);
export default __webpack_public_path__ + "static/media/live.cd1ea88857e27badae1a93a39a3bcfef.svg";
export { ForwardRef as ReactComponent };